import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 0,
}

export const vehicleTabledata = createSlice({
    name: 'vehicleTabledata',
    initialState,
    reducers: {
        addTableData3: (state, action) => {
            state.value = (action.payload);
        },
    },
})

// Action creators are generated for each case reducer function
export const { addTableData3 } = vehicleTabledata.actions

export default vehicleTabledata.reducer